import { PluginSidebar } from '@wordpress/editor';
import { PluginSidebarMoreMenuItem } from '@wordpress/editor';
import { QueryClient, QueryClientProvider } from 'react-query';
import Logo from '../../../img/logo.svg';
import AnalisesTextuais from './AnalisesTextuaisView';
import { ContextTelaProvider } from '../DicasOtimizacao/telaContext';

function MenuLateralAnalises() {
  const queryClient = new QueryClient();

  return (
    <>
      <PluginSidebarMoreMenuItem target="opti-sidebar" icon={<img src={Logo} />}>
        Opti Marketing
      </PluginSidebarMoreMenuItem>

      <PluginSidebar name="opti-sidebar" title="Opti Marketing" icon={<img src={Logo} />}>
        <QueryClientProvider client={queryClient}>
          <ContextTelaProvider>
            <AnalisesTextuais />
          </ContextTelaProvider>
        </QueryClientProvider>
      </PluginSidebar>
    </>
  );
}

export default MenuLateralAnalises;
